<template>
  <span
    class="chat-logo-container"
    :class="`chat-logo-container--${size}`"
  >
    <img v-if="chatName === 'wa_chat_api'" :src="require('../../../assets/images/whatsapp-icon-small.svg')" alt="логотип whatsapp">
    <img v-if="chatName === 'bachata'" :src="require('../../../assets/images/bachata-icon.svg')" alt="логотип bachata">
    <img v-if="chatName === 'waba_gupshup'" :src="require('../../../assets/images/whatsapp-icon-small.svg')" alt="логотип whatsapp">
  </span>
</template>

<script>
export default {
  props: {
    chatName: {
      type: String,
      required: true
    },

    size: {
      type: String,
      default: 'md' // 'sm' | 'md' | 'lg' | 'xl'
    }
  }
}
</script>

<style lang="scss">
  .chat-logo-container {
    img {
      display: block;
      max-width: 100%;
      height: auto;
    }

    &--xs {
      img {
        width: 25px;
      }
    }

    &--sm {
      img {
        width: 40px;
      }
    }

    &--md {
      img {
        width: 80px;
      }
    }

    &--lg {
      img {
        width: 160px;
      }
    }

    &--xl {
      img {
        width: 200px;
      }
    }
  }
</style>
